export default "__VITE_ASSET__BDKG45AZ__"